import React from "react";
import { Helmet } from "react-helmet-async";
import { siteUrl } from "./config";

type SeoProps = {
  title: string;
  description: string;
  canonicalPath: string; // e.g. "/medical"
  ogImage?: string;
  noindex?: boolean;
};

const baseUrl = siteUrl;

const Seo: React.FC<SeoProps> = ({
  title,
  description,
  canonicalPath,
  ogImage,
  noindex,
}) => {
  const path = canonicalPath.startsWith("/") ? canonicalPath : `/${canonicalPath}`;
  const url = `${baseUrl}${path}`;
  const ogImageUrl = ogImage
    ? ogImage.startsWith("http")
      ? ogImage
      : `${baseUrl}${ogImage.startsWith("/") ? "" : "/"}${ogImage}`
    : undefined;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      {ogImageUrl && <meta property="og:image" content={ogImageUrl} />}

      <meta name="twitter:card" content={ogImage ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImageUrl && <meta name="twitter:image" content={ogImageUrl} />}
    </Helmet>
  );
};

export default Seo;

